import { render, staticRenderFns } from "./FilterCard.vue?vue&type=template&id=cb1803d2&scoped=true"
import script from "./FilterCard.ts?vue&type=script&lang=ts&external"
export * from "./FilterCard.ts?vue&type=script&lang=ts&external"
import style0 from "./FilterCard.scss?vue&type=style&index=0&id=cb1803d2&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb1803d2",
  null
  
)

export default component.exports